/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import {
	GET_MAIN_SHAFT_BEARING_RESULT,
	GET_MAIN_SHAFT_UPWINDBEARING_RESULT,
	GET_MAIN_SHAFT_DOWNWINDBEARING_RESULT,
	GET_MAIN_SHAFT_BEARING_SUCCESS,
	GET_MAIN_SHAFT_UPWINDBEARING_SUCCESS,
	GET_MAIN_SHAFT_DOWNWINDBEARING_SUCCESS,
	GET_MAIN_BEARING_RESULT_ERROR,
	RESET_MAIN_BEARING_RESULT,
} from "@/stores/actions/WindDiagnosticMainBearingResult";

const state = {
	status: FetchStatus.Init,
	data:   [],
	error:  {},
};

const actions = {
	[GET_MAIN_SHAFT_BEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_MAIN_SHAFT_BEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/MainBearings`)
			.then((resp) =>
			{
				commit(GET_MAIN_SHAFT_BEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_MAIN_SHAFT_UPWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_MAIN_SHAFT_UPWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/MainBearings`)
			.then((resp) =>
			{
				commit(GET_MAIN_SHAFT_UPWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_BEARING_RESULT_ERROR, error.response);
			});
	},
	[GET_MAIN_SHAFT_DOWNWINDBEARING_RESULT]: ({ commit }, resultSetId) =>
	{
		commit(GET_MAIN_SHAFT_DOWNWINDBEARING_RESULT);

		httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/MainBearings`)
			.then((resp) =>
			{
				commit(GET_MAIN_SHAFT_DOWNWINDBEARING_SUCCESS, resp.data);
			})
			.catch((error) =>
			{
				commit(GET_MAIN_BEARING_RESULT_ERROR, error.response);
			});
	},
	[RESET_MAIN_BEARING_RESULT]: ({ commit }) =>
	{
		commit(RESET_MAIN_BEARING_RESULT);
	},
};

const mutations = {
	[GET_MAIN_SHAFT_BEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_MAIN_SHAFT_UPWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_MAIN_SHAFT_DOWNWINDBEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_MAIN_SHAFT_BEARING_SUCCESS]: (state, data) =>
	{
		state.data = [];
		state.status = FetchStatus.Loaded;
		if (data)
			state.data.push(...data);
	},
	[GET_MAIN_SHAFT_UPWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.data = [];
		state.status = FetchStatus.Loaded;
		if (data)
			state.data.push(...data);
	},
	[GET_MAIN_SHAFT_DOWNWINDBEARING_SUCCESS]: (state, data) =>
	{
		state.data = [];
		state.status = FetchStatus.Loaded;
		if (data)
			state.data.push(...data);
	},
	[GET_MAIN_BEARING_RESULT_ERROR]: (state, error) =>
	{
		state.status = FetchStatus.Error;
		state.error = error;
	},
	[RESET_MAIN_BEARING_RESULT]: (state) =>
	{
		state.status = FetchStatus.Init;
		state.data = [];
	},
};

export default {
	state,
	actions,
	mutations,
};
